export default __webpack_public_path__ + "static/jira-service-management_attribution_dark-be59aec7d20cb9a2c5a1ae995139a47c314f4385eadb194c5b726c3d68e50bf6.svg";